import { Component, ContentChildren, Input, Output, EventEmitter, QueryList, AfterContentInit } from '@angular/core';
import { AccordionTabComponent } from './accordion-tab/accordion-tab.component';

@Component({
    selector: 'accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: false
})
export class AccordionComponent implements AfterContentInit {
  @Input() multiple = false;
  @Input() expandIcon = 'icon-plus';
  @Input() collapseIcon = 'icon-minus';
  @Input() class = '';
  @Input() id?: string;
  @Input() activeIndex: number | number[] | null = null;

  @Output() activeIndexChange = new EventEmitter<number | number[] | null>();

  @ContentChildren(AccordionTabComponent) tabs!: QueryList<AccordionTabComponent>;

  ngAfterContentInit() {
    this.updateOpenTabs();
  }

  toggle(tab: AccordionTabComponent, index: number) {
    if (tab.disabled) return;

    if (this.multiple) {
      const current = Array.isArray(this.activeIndex) ? [...this.activeIndex] : [];
      const idx = current.indexOf(index);
      if (idx > -1) current.splice(idx, 1);
      else current.push(index);
      this.activeIndex = current;
    } else {
      this.activeIndex = this.activeIndex === index ? null : index;
    }

    this.activeIndexChange.emit(this.activeIndex);
    this.updateOpenTabs();
  }

  isOpen(index: number): boolean {
    return this.multiple
      ? Array.isArray(this.activeIndex) && this.activeIndex.includes(index)
      : this.activeIndex === index;
  }

  updateOpenTabs() {
    this.tabs.forEach((tab, index) => {
      tab.active = this.isOpen(index);
    });
  }
}
